/**
 * Opens the header's dropdown / mega menu on mouse hover (desktop only).
 *
 * Dawn's <header-menu> custom element already manages a <details> internally
 * and reacts correctly to the native 'toggle' event (animations, aria state,
 * etc. — see assets/details-disclosure.js). Rather than reimplement any of
 * that, we simply set/remove the details' `open` attribute ourselves on
 * mouseenter/mouseleave, which fires that same native event and reuses all
 * of Dawn's existing open/close logic automatically.
 *
 * Click-to-open still works untouched for touch devices and keyboard users.
 */
(function () {
  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function setup() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;

      let closeTimer;

      menu.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      });

      menu.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
